import { useLingui } from '@lingui/react/macro'

import type { Rule } from 'antd/lib/form'

/* requiredOnly sign in 用到 */
export const usePwdRules = (requiredOnly?: boolean) => {
  const { t } = useLingui()

  const requiredRule = {
    required: true,
    message: requiredOnly
      ? t`Please enter your password.`
      : t`Please enter your new password.`,
  } as Rule

  if (requiredOnly) {
    return [requiredRule]
  }

  return [
    requiredRule,
    {
      pattern: /^(?=.*[a-z])(?=.*\d)[\s\S]{6,16}$/i,
      message: t`Passwords must be 6-16 characters, containing at least 1 letter and 1 number.`,
    },
  ] as Rule[]
}
